import { render, staticRenderFns } from "./GameLife.vue?vue&type=template&id=538254e2&scoped=true&"
import script from "./GameLife.vue?vue&type=script&lang=js&"
export * from "./GameLife.vue?vue&type=script&lang=js&"
import style0 from "./GameLife.vue?vue&type=style&index=0&id=538254e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538254e2",
  null
  
)

export default component.exports